export class ShovalAgentInstallCommand {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "platform",
            "baseName": "platform",
            "type": "ShovalAgentInstallPlatform",
            "format": ""
        },
        {
            "name": "command",
            "baseName": "command",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "scanningAccountId",
            "baseName": "scanningAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "policyName",
            "baseName": "policyName",
            "type": "string",
            "format": ""
        },
        {
            "name": "docsUrl",
            "baseName": "docsUrl",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ShovalAgentInstallCommand.attributeTypeMap;
    }
    constructor() {
    }
}
